import {Prompt, PicLink, EventBanner, Quicklink, EventResources,ScrollReset} from './obj.js'

import b1 from "./img/beginners/1.BPC2025S1 (location TBD).webp"
import b2 from "./img/beginners/2024-beginner-contest-a4.webp"
import b3 from "./img/beginners/IMG_0668.webp"
import b4 from "./img/beginners/IMG_0715.webp"
import b5 from "./img/beginners/IMG_8892.webp"
import b6 from "./img/beginners/IMG_8912.webp"
import b7 from "./img/beginners/IMG_8929.webp"
import b8 from "./img/beginners/PXL_20230722_032126517.MP.webp"

import dmoj from './icons/dmoj_white.png'
import help from './icons/material-symbols_help-outline.svg'

export default function Beginner(){
    return (<>
        <main className = "eventpage">
            <ScrollReset/>
            <EventBanner>Beginner's<br/>Contest</EventBanner>
            <section className= "twocol">
                <Prompt>Held in semester 1, the annual beginner’s contest is aimed at beginner programmers to introduce them to the world of competitive programming. This competition boasts a variety of problems, aimed at introducing the topics a competitive programmer encounters. 
                    <br></br>
                    <br></br>
                    Sporting a $500+ prize pool and free food,  this event is one of MAP’s most popular events.     <br></br>
                </Prompt>
                <div className = 'twobytwo'>
                    <PicLink src = {b1}></PicLink>
                    <PicLink src = {b3}></PicLink>
                    <PicLink src = {b5}></PicLink>
                    <PicLink src = {b7}></PicLink>
                </div>
            </section>
            <section className= "twocol">
                <EventResources>
                    <Quicklink src = {dmoj} path = '/dmoj'>DMOJ</Quicklink>
                    <Quicklink src = {help} path = '/intro-to-cp'>MAPS Intro</Quicklink>
                </EventResources>
                <div className = 'twobytwo'>
                    
                    <PicLink src = {b8}></PicLink>
                    <PicLink src = {b6}></PicLink>
                    <PicLink src = {b4}></PicLink>
                    <PicLink src = {b2}></PicLink>                    
                </div>

            </section>

        </main>
    </>)
}